import { render, staticRenderFns } from "./PaymentsPage.vue?vue&type=template&id=58d09eee&scoped=true"
import script from "./PaymentsPage.vue?vue&type=script&lang=js"
export * from "./PaymentsPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentsPage.vue?vue&type=style&index=0&id=58d09eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d09eee",
  null
  
)

export default component.exports